import api from "./axios";

export const createExhibitor = async (payload) => {
  const response = await api.post("/exhibitor", payload);
  return response.data;
};

export const getExhibitor = async (id) => {
  const response = await api.get(`/exhibitor/company/${id}`);
  return response.data;
};

export const getExhibitorById = (id) => {
  return api.get(`/exhibitor/${id}`);
};

export const updateExhibitor = async (id, payload) => {
  const response = await api.put(`/exhibitor/${id}`, payload);
  return response.data;
};

export const deleteExhibitor = (id, payload) => {
  return api.put(`/exhibitor/delete/${id}`, payload);    
};

